/**
 * Route for `event-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EventTrackingPage } from "../features/event-tracking/EventTrackingPage";

export const eventTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/event-tracking",
	component: EventTrackingPage,
});

export default eventTrackingRoute;
